import virtualvisit from '@organisms/virtualvisit';
import calendly from '@molecules/calendly';
import updateContact from './offer/contact';
import scheduleContact from './offer/contact-schedule';

/**
 * Init Vues, and check if el exist,
 * to avoid warnings when el is not present
 */
export default function () {
  // init virtualvisit
  if (document.querySelector('.virtualvisit') !== null) {
    virtualvisit();
  }
  if (document.querySelector('.rdv') !== null) {
    calendly();
  }

  if (document.querySelector('.contact-completion') !== null) {
    updateContact();
  }

  if (document.querySelector('.contact-schedule') !== null) {
    scheduleContact();
  }
}
